import { Observable } from "rxjs";
import { filter, map, mergeMap } from "rxjs/operators";

import { Injectable } from "@angular/core";

import { Mark, MarkItem, MarkUpsert } from "../../_objects/mark";
import { MarkSchema } from "../../_offline/models/mark.schema";
import { MarkDbService } from "../database/mark-db.service";
import { MarkContractService } from "../interfaces/mark-contract.service";

@Injectable({
  providedIn: "root"
})
export class MarkOfflineService implements MarkContractService {
  public constructor(private markDbService: MarkDbService) {}

  public getMark(): Observable<Mark> {
    return this.getMarkFromDb();
  }

  public upsertMark(markUpsert: MarkUpsert): Observable<Mark> {
    return this.markDbService.getAll().pipe(
      mergeMap((markSchema) => {
        markSchema.items = JSON.stringify(markUpsert.items);
        markSchema.lastUpdateDate = new Date().toISOString();

        return this.markDbService.putAll(markSchema);
      }),
      mergeMap(() => this.getMarkFromDb())
    );
  }

  public parseMarkFromSchema(value: MarkSchema): Mark {
    const result = new Mark();
    result.id = value.id;
    result.items = JSON.parse(value.items) as MarkItem[];
    result.isDeleted = value.isDeleted;
    result.isValid = value.isValid;
    result.createDate = value.createDate;
    result.lastUpdateDate = value.lastUpdateDate;
    result.schemaVersion = value.schemaVersion;
    result.createdBy = value.createdBy;
    result.lastUpdatedBy = value.lastUpdatedBy;
    return result;
  }

  private getMarkFromDb(): Observable<Mark> {
    return this.markDbService.getAll().pipe(
      filter((marks) => !!marks),
      map((value) => this.parseMarkFromSchema(value))
    );
  }
}
